export const safeParseJSON = (maybeJSON) => {
    try {
        const result = JSON.parse(maybeJSON);
        return result;
    }
    catch {
        return null;
    }
};
//# sourceMappingURL=safeParseJSON.js.map